import Vue from 'vue';
import cssVars from 'css-vars-ponyfill';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import heatmap from 'highcharts/modules/heatmap';
import sunburst from 'highcharts/modules/sunburst';
import noData from 'highcharts/modules/no-data-to-display.js';
import LongdoMap from 'longdo-map-vue';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './lang';
import mixins from './mixins';
import directives from '../directives/event';
import axios from './backend/vue-axios';

if (location.protocol !== 'https:') {
  location.replace(`https:${location.href.substring(location.protocol.length)}`);
}
Vue.config.productionTip = false;
Vue.prototype.startSearchDate = '2017-10-01';

sunburst(Highcharts);
heatmap(Highcharts);
noData(Highcharts);
cssVars();

/* Highcharts plugin to handle text symbols */
(function(H) {
  function symbolWrap(proceed, symbol, x, y, w, h, options) {
    if (symbol.indexOf('text:') === 0) {
      const text = symbol.split(':')[1];
      const svgElem = this.text(text, x, y + h).css({
        fontFamily: 'FontAwesome',
        fontSize: h * 2
      });

      if (svgElem.renderer.isVML) {
        svgElem.fillSetter = function(value, key, element) {
          element.style.color = H.Color(value).get('rgb');
        };
      }
      return svgElem;
    }
    return proceed.apply(this, [].slice.call(arguments, 1));
  }
  H.wrap(H.SVGRenderer.prototype, 'symbol', symbolWrap);
  if (H.VMLRenderer) {
    H.wrap(H.VMLRenderer.prototype, 'symbol', symbolWrap);
  }

  // Load the font for SVG files also
  H.wrap(H.Chart.prototype, 'getSVG', function(proceed) {
    let svg = proceed.call(this);
    svg = `${'<?xml-stylesheet type="text/css" ' +
      'href="https://use.fontawesome.com/releases/v5.8.1/css/all.css" ?>'}${svg}`;
    return svg;
  });
})(Highcharts);

Highcharts.setOptions({
  global: {},
  credits: {
    enabled: false
  },
  lang: {
    thousandsSep: ','
  }
});

Vue.mixin(mixins);
Vue.use(HighchartsVue);
Vue.use(VueCookies);
Vue.filter('numFormat', numFormat(numeral));
Vue.use(LongdoMap, {
  load: {
    apiKey: process.env.VUE_APP_LONGDO_MAP_KEY
  }
});

new Vue({
  router,
  axios,
  store,
  vuetify,
  i18n,
  directives,
  render: h => h(App)
}).$mount('#app');
